import React from 'react';
import { 
  Box, 
  IconButton, 
  Typography,
  Slide
} from '@mui/material';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const MobileTranscript = ({ 
  onClose,
  messages = []
}) => {
  const { t } = useTranslation();
  
  return (
    <>
      {/* Semi-transparent overlay */}
      <Box
        onClick={onClose}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1190
        }}
      />
      
      {/* Transcript bottom sheet */}
      <Slide direction="up" in={true} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            height: '78vh', // 70% of viewport height
            backgroundColor: '#FFFFFF',
            zIndex: 1200,
            display: 'flex',
            flexDirection: 'column',
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.1)'
          }}
        >
          {/* Header with title and close button */}
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              borderBottom: '1px solid #E4E4E7',
              padding: '16px 22px',
            }}
          >
            <Typography 
              variant="h2"
              component="h2"
            >
              {t('summary.transcript')}
            </Typography>
            <IconButton 
              onClick={onClose} 
              size="small"
              sx={{
                padding: 0,
              }}
            >
              <X strokeWidth={2} size={24} />
            </IconButton>
          </Box>
          
          {/* Messages list */}
          <Box 
            sx={{ 
              flexGrow: 1, 
              overflowY: 'auto',
              padding: 2,
              backgroundColor: '#FFFFFF',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {messages && messages.length > 0 ? (
              messages.map((message, index) => (
                <Box
                  key={index}
                  sx={{
                    padding: '8px 12px',
                    backgroundColor: '#F4F4F5',
                    borderRadius: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'flex-start',
                    maxWidth: '100%',
                  }}
                >
                  <Typography 
                    variant="body2"
                    sx={{
                      fontFamily: 'Geist',
                      fontWeight: 400,
                      fontSize: 14,
                      lineHeight: 1.3,
                      color: '#3D3D3D',
                      wordBreak: 'break-word',
                    }}
                  >
                    {message}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography 
                variant="body1" 
                sx={{ 
                  textAlign: 'center', 
                  mt: 4,
                  fontFamily: 'Geist',
                  color: '#3D3D3D',
                }}
              >
                {t('summary.noMessagesAvailable')}
              </Typography>
            )}
          </Box>
        </Box>
      </Slide>
    </>
  );
};

export default MobileTranscript; 